import React, { useState, useEffect, useCallback, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Typography, Grid, Button, Chip, Avatar, Skeleton } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import FavoriteIcon from "@mui/icons-material/Favorite";
import axios from "axios";
import { PreRollAd } from './TwinredPreRoll';
import { SinPartyContext } from "../contexts/SinPartyContext";
import { StripchatContext, filterStripchat } from "../contexts/StripchatContext";
import { buildStripchatClickUrl } from "../utils/stripchatP1";

// ─── Category config ───────────────────────────────────────────────────────────
export const CATEGORIES = {
  "latina-cam-girls": {
    title: "Latina Cam Girls",
    h1: "Latina Cam Girls Live Now",
    description:
      "Watch the hottest Latina cam girls streaming live right now. Browse hundreds of beautiful Latina models from Colombia, Mexico, Brazil, Argentina and more. Chat for free, tip, or go private.",
    faq: [
      { q: "Are Latina cam girls really live?", a: "Yes — every model you see is streaming live in real-time. No recordings, no bots." },
      { q: "Is it free to watch?", a: "Free chat is available for all rooms. Private shows require credits." },
      { q: "Can I filter by country?", a: "Yes — use the language filter to find Spanish or Portuguese speakers." },
    ],
    apiParams: { ethnicity: "hispanic" },
    metaDescription: "Watch live Latina cam girls now. Hundreds of Colombian, Mexican, and Brazilian cam models streaming free. Chat, tip, go private.",
    keywords: "latina cam girls, latina live cams, colombian cam girls, mexican cam girls, latin girls live",
  },
  "blonde-cam-girls": {
    title: "Blonde Cam Girls",
    h1: "Blonde Cam Girls Live Now",
    description:
      "Live blonde cam girls streaming now. From natural blondes to platinum, find your perfect match and watch for free. Go private whenever you're ready.",
    faq: [
      { q: "How many blonde cam girls are live?", a: "Typically 80–120 blonde models are live at any given time." },
      { q: "Can I filter by body type?", a: "Yes — use the sidebar filters to narrow by age, ethnicity, and fetishes." },
    ],
    apiParams: { hairColor: "blond" },
    metaDescription: "Watch live blonde cam girls streaming now. Hundreds of natural and platinum blonde models in free chat. Go private anytime.",
    keywords: "blonde cam girls, blonde live cams, blonde webcam girls, blonde cam models",
  },
  "brunette-cam-girls": {
    title: "Brunette Cam Girls",
    h1: "Brunette Cam Girls Live",
    description:
      "Browse hundreds of gorgeous brunette cam girls live streaming right now. Dark hair, brown hair, all brunettes welcome. Free chat always available.",
    faq: [
      { q: "What's the difference between brunette and dark hair?", a: "Brunette covers brown to dark brown; black hair is a separate category. Both are available here." },
    ],
    apiParams: { hairColor: "brunette" },
    metaDescription: "Live brunette cam girls streaming now. Hundreds of dark-haired models in free chat. Watch live, tip, go private.",
    keywords: "brunette cam girls, brunette live cams, dark hair cam girls",
  },
  "milf-cam-girls": {
    title: "MILF Cam Girls",
    h1: "MILF Cam Girls Live Now",
    description:
      "Hot MILF cam girls live and waiting. Mature women 30–50 who know exactly what they want. Watch free, tip, or book a private show.",
    faq: [
      { q: "What age range are MILF performers?", a: "MILF performers are typically 30–50 years old. Use the age filter to narrow your search." },
      { q: "Are MILF shows more expensive?", a: "Pricing is set by each model individually. Many offer competitive rates." },
    ],
    apiParams: { theme: "housewives,milf", ageMin: 30, ageMax: 55 },
    metaDescription: "MILF cam girls live now. Mature women 30–50 streaming free. Watch, chat, go private with experienced models.",
    keywords: "milf cam girls, milf live cams, mature cam girls, cougar cams",
  },
  "teen-cam-girls": {
    title: "Teen Cam Girls 18+ — 100s of Amateur Models Free",
    h1: "Teen Cam Girls Live (18+)",
    description:
      "Legal 18+ teen cam girls streaming live. Browse young amateur models in free chat right now. All performers are verified adults.",
    faq: [
      { q: "Are all teen performers really 18+?", a: "Yes — Streamate verifies age for every performer. All models are 18 or older." },
      { q: "How do I filter for 18–19 year olds?", a: "Use the Age filter in the sidebar and select 'Teen 18+'." },
    ],
    apiParams: { ageMin: 18, ageMax: 21 },
    metaDescription: "Teen cam girls 18+ LIVE now — 100s of young amateur models streaming FREE! All performers verified adults. Chat free, go private.",
    keywords: "teen cam girls 18+, young cam girls, amateur teen cams, 18 cam girls",
  },
  "ebony-cam-girls": {
    title: "Ebony Cam Girls",
    h1: "Ebony Cam Girls Live Now",
    description:
      "Stunning ebony cam girls live streaming right now. Black cam models from the US, Caribbean, Africa, and Brazil. Free chat available 24/7.",
    faq: [
      { q: "How many ebony cam models are online?", a: "Typically 60–100 ebony models are live at any time, more in the evenings." },
    ],
    apiParams: { ethnicity: "ebony" },
    metaDescription: "Ebony cam girls live now. Black models streaming free 24/7. Chat, tip, go private with stunning ebony performers.",
    keywords: "ebony cam girls, black cam girls, ebony live cams, black webcam models",
  },
  "asian-cam-girls": {
    title: "Asian Cam Girls",
    h1: "Asian Cam Girls Live Now",
    description:
      "Beautiful Asian cam girls live right now. Japanese, Korean, Thai, Filipino, Chinese, and Southeast Asian models in free chat. Private shows available.",
    faq: [
      { q: "What time are most Asian cam girls online?", a: "Asian models are most active in Asian evening hours (10 AM–4 PM EST), but many stream at all hours." },
    ],
    apiParams: { ethnicity: "asian" },
    metaDescription: "Asian cam girls live now. Japanese, Korean, Thai, Filipino models in free chat. Go private anytime.",
    keywords: "asian cam girls, asian live cams, japanese cam girls, korean cam girls, thai cam girls",
  },
  "mature-cam-girls": {
    title: "Mature Cam Girls",
    h1: "Mature Cam Girls Live Now",
    description:
      "Experienced mature cam girls 40+ live streaming now. These ladies know exactly how to put on a show. Free chat always open.",
    faq: [
      { q: "What age are 'mature' performers?", a: "Mature performers are 40 and older. Some are 50+. Use the age filter to narrow down." },
      { q: "Do mature models do private shows?", a: "Yes — almost all performers offer free chat plus tipping rooms and private shows." },
    ],
    apiParams: { ageMin: 40, ageMax: 99 },
    metaDescription: "Mature cam girls 40+ live now. Experienced women streaming free. Chat, tip, go private with mature cam models.",
    keywords: "mature cam girls, older cam girls, 40+ cam models, granny cams, experienced cam girls",
  },
  "french-cam-girls": {
    title: "French Cam Girls",
    h1: "French Cam Girls Live Now",
    description:
      "Watch beautiful French cam girls streaming live right now. Francophone models from France, Quebec, Belgium, and Switzerland. Chat en français ou en anglais — private shows available 24/7.",
    faq: [
      { q: "Are there really French-speaking cam girls?", a: "Yes — many models speak French as their first language, from France, Quebec, Belgium, and more." },
      { q: "Can I chat in French?", a: "Absolutely — type in French and most French models will respond in kind." },
      { q: "Is it free to watch?", a: "Free chat is always open. Private shows require credits." },
    ],
    apiParams: { language: "french" },
    metaDescription: "French cam girls live now. Francophone models from France, Quebec, Belgium streaming free. Chat en français, go private anytime.",
    keywords: "french cam girls, cam girls françaises, french live cams, cam français, francophone cam",
  },
  "bbw-cam-girls": {
    title: "BBW Cam Girls",
    h1: "BBW Cam Girls Live Now",
    description:
      "Curvy BBW cam girls live and loving it. Thick, plus-size models with big personalities streaming free right now. Real women, real shows — tip or go private whenever you're ready.",
    faq: [
      { q: "What does BBW mean on cam sites?", a: "BBW stands for Big Beautiful Woman — curvy, plus-size models who embrace their figure." },
      { q: "Do BBW cam girls do private shows?", a: "Yes — almost all models offer free chat plus tipping rooms and private 1-on-1 shows." },
      { q: "How many BBW models are live?", a: "Typically 40–80 BBW models are streaming at any given time." },
    ],
    apiParams: { build: "bbw" },
    metaDescription: "BBW cam girls live now. Curvy plus-size models streaming free 24/7. Chat, tip, go private with real BBW performers.",
    keywords: "bbw cam girls, curvy cam girls, plus size cam girls, thick cam girls, bbw live cams",
  },
  "redhead-cam-girls": {
    title: "Redhead Cam Girls",
    h1: "Redhead Cam Girls Live Now",
    description:
      "Fiery redhead cam girls streaming live right now. Natural gingers, auburn-haired beauties, and dyed redheads in free chat 24/7. Go private whenever you want.",
    faq: [
      { q: "Are these natural redheads?", a: "Both natural redheads and dyed red hair models are included — you can see hair clearly in thumbnails." },
      { q: "How rare are redhead cam girls?", a: "Natural redheads are rare — about 5–10% of performers — making them especially popular." },
      { q: "Is it free to watch?", a: "Free chat is always available. Private shows and tipping rooms require credits." },
    ],
    apiParams: { hairColor: "red" },
    metaDescription: "Redhead cam girls live now. Natural gingers and fiery red-haired models streaming free. Watch, chat, go private 24/7.",
    keywords: "redhead cam girls, ginger cam girls, red hair cam models, redhead live cams",
  },
  "feet-cam-girls": {
    title: "Feet Cam Girls — 60+ Foot Fetish Models Streaming",
    h1: "Feet Cam Girls Live Now",
    description:
      "Live cam girls who love showing off their feet. Browse performers who specialize in foot fetish content — soles, arches, pedicures, and more. Watch in free chat or go private for a custom show.",
    faq: [
      { q: "What do feet cam girls do in shows?", a: "Foot fetish models offer foot reveals, toe wiggles, close-up soles, oil shows, stocking tease, and fully custom private sessions." },
      { q: "Can I request specific foot content?", a: "Yes — go private and type exactly what you want. Most foot models are very accommodating." },
      { q: "Is it free to watch?", a: "Free chat is always open. You can often see feet in free chat before going private." },
      { q: "How many feet cam girls are live?", a: "Typically 60–100 performers with foot fetish tags are online at any given time." },
    ],
    apiParams: { fetish: "feet" },
    metaDescription: "Feet cam girls LIVE now — 60+ foot fetish models streaming FREE! Soles, arches, toe wiggles & custom shows. Watch free, go private.",
    keywords: "feet cam girls, foot fetish cam, feet live cam, foot cam models, toe cam girls, sole cam",
  },
  "roleplay-cam-girls": {
    title: "Roleplay Cam Girls",
    h1: "Roleplay Cam Girls Live Now",
    description:
      "Live cam girls who excel at roleplay fantasies. Whether you want teacher/student, nurse, secretary, or something completely custom — these models bring your fantasy to life in real time. Free chat open now.",
    faq: [
      { q: "What roleplay scenarios do cam girls do?", a: "Popular scenarios include teacher/student, nurse, maid, boss/employee, step-family fantasy, and fully custom storylines — just ask in private." },
      { q: "Do I need to be specific about the scenario?", a: "The more detail the better — most models love clear direction. You can discuss the scenario before going private." },
      { q: "Is roleplay available in free chat?", a: "Light roleplay often happens in free chat. Full immersive sessions are best in private." },
    ],
    apiParams: { fetish: "roleplay" },
    metaDescription: "Roleplay cam girls live now. Cam models who bring your fantasy to life — teacher, nurse, custom scenarios. Go private for the full experience.",
    keywords: "roleplay cam girls, fantasy cam girls, roleplay live cam, cam girls roleplay, fantasy webcam",
  },
  "bdsm-cam-girls": {
    title: "BDSM Cam Girls — Femdom, Bondage & Kinky Cams",
    h1: "BDSM Cam Girls Live Now",
    description:
      "Explore BDSM live with experienced cam girls. Dominant mistresses, submissive models, bondage, spanking, and power exchange — all available in real-time private shows. Browse performers in free chat now.",
    faq: [
      { q: "What BDSM activities do cam girls offer?", a: "Common activities include bondage, spanking, paddling, femdom, pegging, discipline, humiliation, and orgasm denial — all negotiated with the model beforehand." },
      { q: "Can I find both dominant and submissive models?", a: "Yes — use the filters to find Dominant (Domme/Mistress) or Submissive performers based on your preference." },
      { q: "Is BDSM content available in free chat?", a: "Light teasing is sometimes shown in free chat. Full BDSM sessions always happen in private." },
      { q: "Are these professional BDSM performers?", a: "Many have years of experience. You can read their profiles and reviews before booking a session." },
    ],
    apiParams: { fetish: "bdsm" },
    metaDescription: "BDSM cam girls LIVE now — Dommes, submissives, bondage & spanking streaming free. 100s of kinky performers ready. Book private now.",
    keywords: "bdsm cam girls, femdom cam, bondage cam girls, spanking cam, mistress live cam, submissive cam girls",
  },
  "dominant-cam-girls": {
    title: "Dominant Cam Girls",
    h1: "Dominant Cam Girls — Live Femdom Now",
    description:
      "Commanding dominant cam girls live right now. These Mistresses take control — humiliation, edging, orgasm control, and full femdom sessions. Kneel and enter free chat.",
    faq: [
      { q: "What is a dominant cam girl?", a: "A dominant model (Domme or Mistress) takes the controlling role in a session — giving orders, setting rules, and directing the experience." },
      { q: "What does femdom mean?", a: "Femdom = female domination. The model is in charge. You follow her lead." },
      { q: "Do I need experience with femdom?", a: "No — many Dommes enjoy training beginners. Just be honest about your experience level." },
    ],
    apiParams: { fetish: "dominant" },
    metaDescription: "Dominant cam girls live now. Mistresses and Dommes for femdom, humiliation, edging, and orgasm control. Go private to surrender.",
    keywords: "dominant cam girls, femdom cam, mistress live cam, domme webcam, female domination cam",
  },
  "submissive-cam-girls": {
    title: "Submissive Cam Girls",
    h1: "Submissive Cam Girls Live Now",
    description:
      "Sweet and submissive cam girls live and ready to please. These models love being directed, following your lead, and giving you full control. Browse in free chat and take charge.",
    faq: [
      { q: "What makes a cam girl submissive?", a: "Submissive models enjoy being directed by the viewer — following instructions, wearing outfits on request, and performing tasks you assign." },
      { q: "Can I give instructions in free chat?", a: "Light direction is usually fine in free chat. For full control and explicit instruction, go private." },
    ],
    apiParams: { fetish: "submissive" },
    metaDescription: "Submissive cam girls live now. Models who love being directed and pleasing you. Browse free chat and take control.",
    keywords: "submissive cam girls, obedient cam models, sub cam girls, submissive webcam, cam girl sub",
  },
  "squirt-cam-girls": {
    title: "Squirt Cam Girls",
    h1: "Squirt Cam Girls Live Now",
    description:
      "Watch real squirt shows from live cam girls streaming right now. These models are known for their explosive wet performances — free chat open, private shows bookable instantly.",
    faq: [
      { q: "Do squirt cam girls really squirt?", a: "Yes — these are performers known for authentic squirt shows. Many have video previews or reviews you can check first." },
      { q: "Can I request a squirt show?", a: "Yes — go private and ask. Tip goals in free chat also often unlock squirt shows." },
      { q: "How do I find the best squirt performers?", a: "Sort by rating or check performer profiles for squirt tags and review mentions." },
    ],
    apiParams: { fetish: "squirt" },
    metaDescription: "Squirt cam girls live now. Real wet shows from verified squirt performers. Watch free chat or book a private show instantly.",
    keywords: "squirt cam girls, squirting cam, wet show cam girls, squirt live cam, squirting webcam models",
  },
  "interactivetoy-cam-girls": {
    title: "Interactive Toy Cam Girls",
    h1: "Interactive Toy Cam Girls — Control Her Vibe",
    description:
      "Cam girls with interactive vibrators you control in real time. Tip to buzz — the more you tip, the more intense the reaction. Watch the fun in free chat or book a private session.",
    faq: [
      { q: "How do interactive toys work?", a: "Models wear app-connected vibrators (like Lovense or OhMiBod). Your tips control the vibration intensity directly in real time." },
      { q: "Can I control the toy in free chat?", a: "Yes — just tip in the free chat room. The tip amount determines the vibration pattern." },
      { q: "What devices do they use?", a: "Most models use Lovense Lush, Domi, or similar toys. Check the model's profile for specifics." },
    ],
    apiParams: { fetish: "interactivevibe" },
    metaDescription: "Interactive toy cam girls live now. Control her vibrator with tips in real time. Lovense models streaming free — go private for full control.",
    keywords: "interactive toy cam girls, lovense cam girls, interactive vibe cam, tip controlled cam, remote vibe cam",
  },
  "voyeur-cam-girls": {
    title: "Voyeur Cam Girls",
    h1: "Voyeur Cam Girls — Watch Without Being Watched",
    description:
      "Voyeur cam girls streaming live for viewers who love to watch. Spy cam vibes, exhibitionist models who don't mind — or don't know — that you're there. Browse free, stay anonymous.",
    faq: [
      { q: "What is a voyeur cam show?", a: "Voyeur shows give viewers an unobserved watching experience — models act naturally or set up scenes as if unaware of the camera." },
      { q: "Are voyeur models really exhibitionists?", a: "Many voyeur-tagged models are genuine exhibitionists who enjoy being watched. Others create a staged voyeur experience." },
    ],
    apiParams: { fetish: "voyeur" },
    metaDescription: "Voyeur cam girls live now. Watch exhibitionist models stream free — spy cam vibes, natural performances, stay anonymous.",
    keywords: "voyeur cam girls, spy cam girls, exhibitionist cam, voyeur live cam, watch cam girls anonymous",
  },
  "amateur-cam-girls": {
    title: "Amateur Cam Girls",
    h1: "Amateur Cam Girls Live Now",
    description:
      "Watch real amateur cam girls streaming live right now. First-time performers, girl-next-door types, and genuine beginners in free chat. No scripts, no studios — just real girls on cam.",
    faq: [
      { q: "What makes a cam girl 'amateur'?", a: "Amateur models are typically new to camming or perform from home without a studio setup — authentic, unscripted, and real." },
      { q: "Are amateur shows free to watch?", a: "Free chat is always available. Private shows and tips are optional." },
    ],
    apiParams: { theme: "amateur" },
    metaDescription: "Amateur cam girls live now. Real girl-next-door performers streaming free. No scripts, no studios — just authentic live shows.",
    keywords: "amateur cam girls, amateur live cams, real cam girls, girl next door cam, homemade cam girls",
  },
  "college-cam-girls": {
    title: "College Cam Girls 18–22 — Real Students Streaming",
    h1: "College Cam Girls Live Now",
    description:
      "Young college cam girls 18–22 streaming live right now. College students, sorority girls, and campus cuties in free chat. All performers verified 18+.",
    faq: [
      { q: "Are college cam girls really students?", a: "Many are real college students camming part-time. All are verified 18+ adults." },
      { q: "What ages are college cam girls?", a: "Typically 18–22 years old. Use the age filter to narrow your search." },
    ],
    apiParams: { ageMin: 18, ageMax: 22, theme: "college" },
    metaDescription: "College cam girls 18–22 LIVE now — real students streaming FREE! Sorority girls, campus cuties, all verified 18+. Go private anytime.",
    keywords: "college cam girls, college live cams, student cam girls, sorority cam, young cam girls 18+",
  },
  "tattoo-cam-girls": {
    title: "Tattoo Cam Girls",
    h1: "Tattoo Cam Girls Live Now",
    description:
      "Inked and tattooed cam girls streaming live right now. Full sleeves, back pieces, and body art on display. Watch tattoo models in free chat or go private.",
    faq: [
      { q: "Do tattoo cam girls show off their ink?", a: "Yes — many tattooed models love showing off their body art. Ask in chat and they'll happily show you their ink." },
      { q: "Can I filter by tattoo style?", a: "Browse the tattoo category to find inked models. Each model's profile shows their tattoo details." },
    ],
    apiParams: { fetish: "tattoos" },
    metaDescription: "Tattoo cam girls live now. Inked models with full sleeves, body art, and piercings streaming free. Watch, chat, go private.",
    keywords: "tattoo cam girls, inked cam girls, tattooed cam models, body art cam, tattoo live cams",
  },
  "big-ass-cam-girls": {
    title: "Big Ass Cam Girls",
    h1: "Big Ass Cam Girls Live Now",
    description:
      "Thick and curvy big ass cam girls streaming live right now. Booty lovers rejoice — twerking, bouncing, and showing off in free chat. Go private for the full experience.",
    faq: [
      { q: "What kind of shows do big ass cam girls do?", a: "Twerking, booty shaking, oil shows, and close-up views are popular. Go private for custom requests." },
      { q: "Are these real curves?", a: "Yes — browse thumbnails and live previews to see real curves in real time." },
    ],
    apiParams: { fetish: "big-ass" },
    metaDescription: "Big ass cam girls live now. Thick, curvy models twerking and streaming free. Watch, chat, go private for custom shows.",
    keywords: "big ass cam girls, big booty cam, thick cam girls, curvy ass cam, booty cam girls",
  },
  "natural-tits-cam-girls": {
    title: "Natural Tits Cam Girls",
    h1: "Natural Tits Cam Girls Live Now",
    description:
      "All-natural cam girls streaming live right now. No implants, no enhancements — just gorgeous natural bodies on display. Free chat open 24/7.",
    faq: [
      { q: "How do I know they're natural?", a: "Models tagged as natural have no implants or enhancements. What you see is 100% real." },
      { q: "Can I filter by breast size?", a: "Browse the natural tits category for all-natural models. Size varies from petite to busty." },
    ],
    apiParams: { fetish: "natural-tits" },
    metaDescription: "Natural tits cam girls live now. All-natural bodies streaming free — no implants, no enhancements. Watch, chat, go private.",
    keywords: "natural tits cam girls, natural boobs cam, all natural cam girls, real tits cam, natural breast cam",
  },
  "anal-cam-girls": {
    title: "Anal Cam Girls",
    h1: "Anal Cam Girls Live Now",
    description:
      "Cam girls who specialize in anal play streaming live right now. From teasing to full anal shows — these models love backdoor action. Free chat open, private shows available.",
    faq: [
      { q: "Do anal cam girls perform in free chat?", a: "Light teasing may happen in free chat. Full anal shows are typically in private or tip-goal rooms." },
      { q: "Can I request specific anal content?", a: "Yes — go private and discuss your preferences. Most anal models are very accommodating." },
    ],
    apiParams: { fetish: "anal" },
    metaDescription: "Anal cam girls live now. Models specializing in anal play streaming free. Watch, chat, book a private show for the full experience.",
    keywords: "anal cam girls, anal live cam, anal webcam models, backdoor cam girls, anal cam shows",
  },
  "ukrainian-cam-girls": {
    title: "Ukrainian Cam Girls",
    h1: "Ukrainian Cam Girls Live Now",
    description:
      "Beautiful Ukrainian cam girls streaming live right now. Stunning models from Kyiv, Odesa, Lviv, and across Ukraine. Free chat available 24/7 — go private anytime.",
    faq: [
      { q: "Are Ukrainian cam girls really from Ukraine?", a: "Yes — these models are verified as being from Ukraine. Many speak Ukrainian, Russian, and English." },
      { q: "What time are Ukrainian models online?", a: "Most active during European evening hours (12 PM–8 PM EST), but many stream around the clock." },
    ],
    apiParams: { ethnicity: "caucasian" },
    metaDescription: "Ukrainian cam girls live now. Beautiful models from Ukraine streaming free. Chat, tip, go private with stunning Ukrainian performers.",
    keywords: "ukrainian cam girls, ukraine cam models, ukrainian live cams, kyiv cam girls, eastern european cam",
  },
  "czech-cam-girls": {
    title: "Czech Cam Girls",
    h1: "Czech Cam Girls Live Now",
    description:
      "Gorgeous Czech cam girls streaming live right now. Models from Prague, Brno, and across the Czech Republic. Free chat open — go private for the full experience.",
    faq: [
      { q: "Are Czech cam girls really from the Czech Republic?", a: "Yes — these models are verified as being from the Czech Republic. Many speak Czech, English, and German." },
      { q: "Why are Czech cam girls so popular?", a: "The Czech Republic has a strong camming industry with professional, stunning models known for quality shows." },
    ],
    apiParams: { ethnicity: "caucasian" },
    metaDescription: "Czech cam girls live now. Beautiful models from Prague and the Czech Republic streaming free. Chat, tip, go private anytime.",
    keywords: "czech cam girls, czech live cams, prague cam girls, czech republic cam models, czech webcam",
  },
  "couples-cam": {
    title: "Couples Cam",
    h1: "Couples Cam — Live Now",
    description:
      "Real couples streaming live together right now. Watch authentic chemistry, amateur couples, and pro partners put on shows you won't see anywhere else. Free chat open — jump into a private session anytime.",
    faq: [
      { q: "Are these real couples?", a: "Yes — most are genuine partners streaming together from home. You'll see real chemistry that solo shows can't match." },
      { q: "What happens in couples shows?", a: "Expect teasing, foreplay, and full sessions. Private rooms unlock custom requests — just ask." },
      { q: "Is it free to watch?", a: "Free chat is always open. Private 1-on-2 shows use credits." },
    ],
    apiParams: { theme: "couples" },
    metaDescription: "Live couples cam shows streaming free now. Real couples streaming together. Watch, chat, go private for a custom couples show.",
    keywords: "couples cam, couples live cam, couple webcam, live couples streaming, amateur couples cam, couple cam shows",
  },
  "big-tits-cam-girls": {
    title: "Big Tits Cam Girls",
    h1: "Big Tits Cam Girls Live Now",
    description:
      "Busty cam girls with big natural and enhanced tits streaming live right now. DD, E, F cups and beyond — watch them jiggle, bounce, and tease in free chat. Go private whenever you want more.",
    faq: [
      { q: "What cup sizes are featured?", a: "This category pulls D, DD, DDD, F, G cups and larger — basically anything above a D cup." },
      { q: "Are the tits natural or enhanced?", a: "Both — you'll see all-natural busty models and enhanced ones. Filter by 'natural' for a stricter view." },
      { q: "How many busty models are online?", a: "Typically 100+ big tit models stream at any time, more in peak evening hours." },
    ],
    apiParams: { cupSize: "D,DD,DDD,F,G" },
    metaDescription: "Big tits cam girls live now. DD+ busty models streaming free — natural and enhanced. Watch, tip, go private 24/7.",
    keywords: "big tits cam girls, busty cam girls, big boobs cam, dd cup cam models, huge tits live cam, big tit webcam",
  },
  "masturbation-cams": {
    title: "Masturbation Cams",
    h1: "Live Masturbation Cams",
    description:
      "Cam girls getting off on camera right now. Solo masturbation, fingers, toys, vibrators — watch real pleasure live. Free chat always open, private sessions make it personal.",
    faq: [
      { q: "Is this real masturbation?", a: "Yes — these are real performers enjoying themselves live. Many hit real orgasms on cam, especially in private." },
      { q: "Can I direct the show?", a: "In private, absolutely. Tell her how slow or fast, what toys, and what position — she'll follow." },
      { q: "Are masturbation shows free?", a: "Free chat teasing is common. Full solo shows are usually in private or tip-goal rooms." },
    ],
    apiParams: { fetishes: "masturbation" },
    metaDescription: "Live masturbation cams streaming free now. Watch real solo shows with fingers, toys, and vibrators. Go private for custom requests.",
    keywords: "masturbation cams, solo cam girls, live masturbation, cam girl masturbating, solo webcam girls, live self pleasure cam",
  },
  "striptease-cams": {
    title: "Striptease Cams",
    h1: "Striptease Cams Live Now",
    description:
      "Slow, sexy strip shows live on cam right now. Models peel off lingerie, outfits, and uniforms one piece at a time. Watch the tease build in free chat — go private to set the pace yourself.",
    faq: [
      { q: "What's a striptease cam show?", a: "Performers do slow, deliberate strips — sometimes to music, sometimes with outfits and roleplay. Built for pure anticipation." },
      { q: "Can I request specific outfits?", a: "Yes — go private and ask. Many models have extensive lingerie and costume wardrobes." },
      { q: "Are these shows free?", a: "Teasing often happens in free chat. Full strips typically live in tip-goal rooms or private." },
    ],
    apiParams: { theme: "striptease" },
    metaDescription: "Live striptease cams streaming now. Watch slow sexy strip shows with lingerie, outfits, and roleplay. Free chat open, private shows available.",
    keywords: "striptease cams, strip cam girls, live striptease, strip show cam, cam girl strip, lingerie strip cam",
  },
  "lovense-cams": {
    title: "Lovense Cams",
    h1: "Lovense Cams — Tip to Buzz",
    description:
      "Cam girls wearing Lovense toys you control with tips. Every tip triggers real vibration — more tips, more intensity. Watch her reactions in real time and get her off with your wallet.",
    faq: [
      { q: "How does Lovense work on cam?", a: "Models wear an app-connected Lovense Lush or Domi. Your tips convert directly to vibration patterns and intensity." },
      { q: "What tip amounts do what?", a: "Each model sets her own tip menu — small tips = short buzz, bigger tips = longer, stronger vibes. It's listed in her room." },
      { q: "Can I get exclusive control?", a: "Yes — in private shows, you typically control the toy exclusively for the session length." },
    ],
    apiParams: { fetishes: "interactive" },
    metaDescription: "Lovense cams live now. Control her vibrator with tips in real time. Watch reactions, tip to buzz, go private for full control.",
    keywords: "lovense cams, lovense cam girls, interactive toy cam, tip vibe cam, lovense lush cam, remote control cam girls",
  },
  "oil-show-cams": {
    title: "Oil Show Cams",
    h1: "Oil Show Cams Live Now",
    description:
      "Cam girls covered in oil, glistening under the light. Watch slick bodies slide, stretch, and shine live. Oil shows in free chat sometimes, custom in private.",
    faq: [
      { q: "What happens in an oil show?", a: "Models apply baby oil, massage oil, or coconut oil over their body — tits, ass, legs. Expect slow, sensual application and plenty of close-ups." },
      { q: "Can I request specific oil content?", a: "Yes — in private you can ask for specific areas, poses, or toys paired with the oil." },
      { q: "Are oil shows free to watch?", a: "Some models run oil tip-goals in free chat. Full shows typically happen in private." },
    ],
    apiParams: { fetishes: "fetish,oil" },
    metaDescription: "Oil show cams live now. Watch cam girls glisten with oil in real time — free chat teasing, private shows custom.",
    keywords: "oil show cams, oil cam girls, oiled up cam, oil massage cam, oil fetish cam, slick cam girls",
  },
  "dirty-talk-cams": {
    title: "Dirty Talk Cams",
    h1: "Dirty Talk Cams Live Now",
    description:
      "Cam girls who talk filthy in real time. Moaning, whispering, filthy fantasies narrated live — headphones recommended. Free chat teasers, full verbal in private.",
    faq: [
      { q: "Do dirty talk models use their real voice?", a: "Yes — live voice, no scripts. Just tell her what you want to hear and she'll take the lead." },
      { q: "What accents are available?", a: "American, British, Latina, Russian, Asian — you can filter by language to find your favorite accent." },
      { q: "Can she do JOI?", a: "Absolutely — jerk-off instruction is one of the most common dirty talk requests. Just ask in private." },
    ],
    apiParams: { fetishes: "roleplay" },
    metaDescription: "Dirty talk cam girls live now. Real voice, real filth — moaning, whispering, JOI and fantasy narration. Go private for full verbal shows.",
    keywords: "dirty talk cams, dirty talk cam girls, joi cam girls, cam girl moaning, dirty talk live, filthy talk webcam",
  },
  "spanish-cam-girls": {
    title: "Spanish Cam Girls",
    h1: "Spanish Cam Girls Live Now",
    description:
      "Chicas calientes de habla hispana en vivo. Spanish-speaking cam girls from Spain, Mexico, Colombia, Argentina and beyond. Habla en español o inglés — entra al chat gratis.",
    faq: [
      { q: "Can I chat in Spanish?", a: "Sí — most Spanish-speaking models prefer it. Type in Spanish and they'll respond in kind." },
      { q: "Where are they from?", a: "A mix — Spain, Mexico, Colombia, Venezuela, Argentina, Chile. Each model's country is listed on her profile." },
      { q: "Is free chat available?", a: "Yes — free chat is always open. Private shows use credits." },
    ],
    apiParams: { language: "spanish" },
    metaDescription: "Spanish cam girls live now. Chicas de habla hispana streaming free. Chat en español, go private with hot Spanish-speaking models.",
    keywords: "spanish cam girls, chicas webcam en vivo, cam girls en español, spanish speaking cam girls, spain cam models, hispanic webcam",
  },
  "blowjob-cams": {
    title: "Blowjob Cams",
    h1: "Blowjob Cams Live Now",
    description:
      "Cam girls who love sucking — dildos, toys, and real partners in couples rooms. Watch technique and tease in free chat, request exactly what you want in private.",
    faq: [
      { q: "Are blowjob cams solo or couples?", a: "Both — solo girls use realistic dildos and toys, while couples feature real blowjob action with a partner." },
      { q: "Can I request specific techniques?", a: "Yes — in private tell her sloppy, slow, deep, eye-contact — whatever you want. Most are very responsive." },
      { q: "Is this available in free chat?", a: "Some teasing happens in free chat. Full shows are in private or tip-goal rooms." },
    ],
    apiParams: { fetishes: "blowjob" },
    metaDescription: "Blowjob cams live now. Solo dildo shows and real couples blowjob action streaming free. Go private for custom technique requests.",
    keywords: "blowjob cams, blowjob cam girls, cam girl blowjob, bj cam live, cam girl sucking, blowjob webcam",
  },
  "deepthroat-cams": {
    title: "Deepthroat Cams",
    h1: "Deepthroat Cams Live Now",
    description:
      "Cam girls with no gag reflex taking toys and partners all the way. Watch real deepthroat skills live — sloppy, messy, authentic. Free chat open, private for custom sessions.",
    faq: [
      { q: "Is this real deepthroat?", a: "Yes — these models specialize in deep throat technique. Expect real tears, drool, and the full works." },
      { q: "Are there size filters?", a: "Profiles list which toys each model uses — from standard to XXL. Ask in chat if you want a specific size." },
      { q: "Can I watch in free chat?", a: "Teasers often happen in free chat. Full deepthroat sessions are typically private or tip-goal." },
    ],
    apiParams: { fetishes: "deepthroat" },
    metaDescription: "Deepthroat cams live now. Cam girls with no gag reflex taking toys and partners deep. Watch sloppy authentic shows free, go private for custom.",
    keywords: "deepthroat cams, deepthroat cam girls, sloppy cam girls, deep throat webcam, cam girl deepthroating, no gag cam",
  },
  "cowgirl-cams": {
    title: "Cowgirl Cam Girls",
    h1: "Cowgirl Cams Live Now",
    description:
      "Cam girls riding toys and partners in cowgirl position. Watch them bounce, grind, and ride live. Perfect POV angle — free chat open, go private to call the pace.",
    faq: [
      { q: "What does cowgirl mean on cam?", a: "Models ride dildos, suction-cup toys, or partners in the cowgirl position — facing the camera, giving you the POV angle." },
      { q: "Reverse cowgirl too?", a: "Yes — many models do both forward and reverse cowgirl. Just ask in private or request the angle in chat." },
      { q: "Is this free to watch?", a: "Teasing in free chat is common. Full riding shows are typically in tip-goal rooms or private." },
    ],
    apiParams: { fetishes: "cowgirl" },
    metaDescription: "Cowgirl cams live now. Watch cam girls ride toys and partners POV-style. Free chat open, go private to set the pace.",
    keywords: "cowgirl cams, cowgirl cam girls, reverse cowgirl cam, pov riding cam, cam girl riding, riding toy cam",
  },
  "topless-cams": {
    title: "Topless Cam Girls",
    h1: "Topless Cams Live Now",
    description:
      "Cam girls who go topless in free chat. Casual, low-pressure, just tits on screen while you hang out. Watch free, tip what you want, go private whenever.",
    faq: [
      { q: "Are they topless in free chat?", a: "Yes — these models show tits in free chat. Lower bodies stay covered until private or tip goals." },
      { q: "Why is topless a separate category?", a: "Many users just want casual topless chill time without full nudity. These models deliver exactly that." },
      { q: "Can I request specific poses?", a: "Yes — even in free chat many will pose for tips. Private opens up full requests." },
    ],
    apiParams: { theme: "topless" },
    metaDescription: "Topless cam girls live now. Free chat with tits on display — casual, no pressure. Go private for full shows anytime.",
    keywords: "topless cams, topless cam girls, free topless cam, free chat topless, topless webcam, tits cam girls",
  },
  "twerk-cams": {
    title: "Twerk Cams",
    h1: "Twerk Cams Live Now",
    description:
      "Cam girls bouncing, dropping, and twerking live. Ass shaking, booty clapping, dance routines — watch them move in free chat. Go private for a personal session.",
    faq: [
      { q: "What counts as a twerk show?", a: "Booty bouncing, ass-clapping, slow-mo drops, choreographed twerking — anything with rhythm and a focus on the backside." },
      { q: "Can I request a specific song?", a: "Yes — just ask in chat. Most models have speakers and will queue up your request in private." },
      { q: "Free chat twerk?", a: "Absolutely — many models twerk in free chat to earn tips. Full routines often happen in tip-goal rooms." },
    ],
    apiParams: { fetishes: "dancing" },
    metaDescription: "Twerk cams live now. Watch cam girls twerking, booty-clapping, and dancing free. Go private for custom routines.",
    keywords: "twerk cams, twerking cam girls, booty cam, cam girl twerking, ass clapping cam, dance cam girls",
  },
  "ahegao-cams": {
    title: "Ahegao Cams",
    h1: "Ahegao Cams Live Now",
    description:
      "Cam girls mastering the ahegao face — rolled eyes, tongue out, lost in pleasure. Anime-inspired expressions on real performers. Watch the fun live in free chat or go private.",
    faq: [
      { q: "What is ahegao?", a: "Ahegao is a Japanese anime expression — eyes rolled back, tongue out, face of pure overwhelmed pleasure. Lots of cam girls nail it." },
      { q: "Who does ahegao best?", a: "Anime-fan models and cosplay performers — check the cosplay and anime tags too for crossover." },
      { q: "Can I request it?", a: "Yes — just ask in private. Many models have signature ahegao faces they love showing off." },
    ],
    apiParams: { fetishes: "ahegao" },
    metaDescription: "Ahegao cams live now. Cam girls with rolled-eye tongue-out ahegao faces streaming live. Watch, tip, go private for the full show.",
    keywords: "ahegao cams, ahegao cam girls, anime face cam, tongue out cam, ahegao webcam, hentai face cam girls",
  },
  "indian-cam-girls": {
    title: "Indian Cam Girls — 50+ Desi Models Streaming",
    h1: "Indian Cam Girls Live Now",
    description:
      "Beautiful Indian cam girls streaming live right now. Desi models from India and the diaspora — Hindi, Punjabi, Tamil speakers in free chat. Go private for the full experience.",
    faq: [
      { q: "Are Indian cam girls really Indian?", a: "Yes — models are verified as Indian or South Asian. Many are in India, others part of the global diaspora." },
      { q: "Can I chat in Hindi?", a: "Yes — many Indian models speak Hindi, Punjabi, Tamil, or Urdu alongside English. Ask in chat." },
      { q: "When are they online?", a: "Peak hours match Indian evenings (9 AM–3 PM EST), but diaspora models stream around the clock." },
    ],
    apiParams: { ethnicity: "indian" },
    metaDescription: "Indian cam girls LIVE now — 50+ desi models streaming free! Hindi, Punjabi & Tamil speakers. Watch free, go private anytime.",
    keywords: "indian cam girls, desi cam girls, indian live cams, hindi cam girls, desi webcam, punjabi cam models",
  },
  "russian-cam-girls": {
    title: "Russian Cam Girls",
    h1: "Russian Cam Girls Live Now",
    description:
      "Gorgeous Russian cam girls streaming live right now. Models from Moscow, St. Petersburg, and across Russia in free chat. Russian and English both welcome.",
    faq: [
      { q: "Are Russian cam girls really from Russia?", a: "Yes — most are based in Russia, others from Russian-speaking regions like Belarus or Kazakhstan. All verified." },
      { q: "Can I chat in Russian?", a: "Absolutely — many Russian models prefer it. Most also speak English." },
      { q: "When are Russian models most active?", a: "Peak hours follow Moscow evenings (12 PM–8 PM EST), but many stream around the clock." },
    ],
    apiParams: { language: "russian" },
    metaDescription: "Russian cam girls live now. Stunning models from Moscow and across Russia streaming free. Chat in Russian or English, go private anytime.",
    keywords: "russian cam girls, russian live cams, moscow cam girls, russian webcam models, eastern european cam, russian cam",
  },
  "arab-cam-girls": {
    title: "Arab Cam Girls",
    h1: "Arab Cam Girls Live Now",
    description:
      "Middle Eastern cam girls streaming live right now. Arab models from Lebanon, Egypt, Morocco, UAE and beyond. Free chat open, private shows available.",
    faq: [
      { q: "Are they really Arab?", a: "Yes — models are verified as Middle Eastern. Many are Lebanese, Egyptian, Moroccan, or from the Gulf region." },
      { q: "Can I chat in Arabic?", a: "Many Arab models speak Arabic and English. Type in Arabic and they'll often respond in kind." },
      { q: "When are Arab cam girls online?", a: "Most active during Middle East evening hours (1 PM–8 PM EST). Others stream 24/7." },
    ],
    apiParams: { ethnicity: "middle eastern" },
    metaDescription: "Arab cam girls live now. Middle Eastern models from Lebanon, Egypt, and beyond streaming free. Chat in Arabic or English, go private anytime.",
    keywords: "arab cam girls, middle eastern cam girls, lebanese cam, egyptian cam girls, arabic cam models, arab webcam",
  },
  "hd-cams": {
    title: "HD Cams",
    h1: "HD Cam Girls Live Now",
    description:
      "Only the best quality streams — HD and 4K cam girls live right now. Crystal clear picture, smooth framerate, pro-quality setups. Free chat, premium viewing.",
    faq: [
      { q: "What counts as HD?", a: "HD streams run at 720p or higher — many models shoot in 1080p or even 4K with high-end cameras." },
      { q: "Is HD free to watch?", a: "Yes — HD streams are available in free chat just like standard quality. No paywall for quality." },
      { q: "Do I need fast internet?", a: "A decent connection (5+ Mbps) handles HD easily. Most modern connections work fine." },
    ],
    apiParams: { theme: "exhibitionist" },
    metaDescription: "HD cam girls live now. Crystal-clear 720p and 1080p streams with pro-quality setups. Free chat available, premium viewing.",
    keywords: "hd cam girls, hd webcam girls, 1080p cam girls, high definition cam, 4k cam girls, hd live cams",
  },
  "petite-cam-girls": {
    title: "Petite Cam Girls",
    h1: "Petite Cam Girls Live Now",
    description:
      "Small, slim, petite cam girls streaming live right now. Tiny frames, flat-to-small chests, all-natural bodies. Free chat open — go private for a personal show.",
    faq: [
      { q: "How small is petite?", a: "Petite models are typically under 5'5\" with slim builds. Many are under 100 lbs with natural bodies." },
      { q: "Is petite the same as skinny?", a: "Similar — petite emphasizes overall small frame (including height), skinny focuses on body fat. Both blend here." },
      { q: "How many petite models are online?", a: "Typically 80–120 petite models stream at once. Peak evening hours see more." },
    ],
    apiParams: { build: "slim,petite" },
    metaDescription: "Petite cam girls live now. Small slim models with natural bodies streaming free. Watch, tip, go private for a custom show.",
    keywords: "petite cam girls, small cam girls, skinny cam girls, slim cam models, tiny cam girls, petite webcam",
  },
  "muscle-cam-girls": {
    title: "Muscle Cam Girls",
    h1: "Muscle & Athletic Cam Girls Live",
    description:
      "Fit, athletic, muscular cam girls live right now. Defined abs, strong arms, lifter physiques, yoga bodies — real fitness on cam. Free chat open, private for custom.",
    faq: [
      { q: "Are they actually muscular?", a: "Yes — this category pulls fit and muscular builds. Expect visible abs, defined arms, strong legs." },
      { q: "What workouts do they do?", a: "Some do yoga, some lift, others cross-train. Ask in chat — many love talking fitness before going private." },
      { q: "Can I request flexing?", a: "Absolutely — flex shows, muscle worship, and fitness roleplay are common requests in private." },
    ],
    apiParams: { build: "athletic,muscular" },
    metaDescription: "Muscle cam girls live now. Fit athletic models with defined abs streaming free. Flex shows, muscle worship, go private for custom.",
    keywords: "muscle cam girls, fit cam girls, athletic cam girls, muscular cam models, fitness cam girls, strong cam girls",
  },

  // ── Compound / cross-category pages (added 2026-04-28) — Jerkmate-style long-tail SEO ──
  "latina-big-tits": {
    title: "Latina Big Tits Cam Girls",
    h1: "Latina Big Tits Cam Girls Live",
    description: "Curvy Latina cam girls with big tits live right now. Colombian, Mexican, and Brazilian models with natural or enhanced curves streaming free. Chat, tip, go private.",
    faq: [
      { q: "Are these Latina models with big tits?", a: "Yes — this filter combines Latina ethnicity with big tits build for the ultimate curvy Latina experience." },
      { q: "Can I go private?", a: "Yes — private shows start in seconds. Prices vary by model." },
    ],
    apiParams: { ethnicity: "hispanic", cupSize: "dd/e,dd" },
    metaDescription: "Latina big tits cam girls live now. Curvy Colombian, Mexican, Brazilian models streaming free. Chat or go private.",
    keywords: "latina big tits cam, latina busty cam girls, curvy latina cam, big tits latina live",
  },
  "latina-milf": {
    title: "Latina MILF Cam Girls",
    h1: "Latina MILF Cam Girls Live Now",
    description: "Sexy Latina MILFs live on cam right now. Experienced mature Latina women 30–50 streaming free. The perfect combination of passion and experience.",
    faq: [
      { q: "What age are Latina MILFs?", a: "Latina MILF performers are typically 30–50. Use the age filter to narrow down." },
    ],
    apiParams: { ethnicity: "hispanic", ageMin: 30, ageMax: 55 },
    metaDescription: "Latina MILF cam girls live now. Experienced mature Latina women streaming free. Chat, tip, or go private.",
    keywords: "latina milf cam, latina mature cam girls, milf latina live, latin cougar cam",
  },
  "latina-amateur": {
    title: "Latina Amateur Cam Girls",
    h1: "Latina Amateur Cam Girls Live",
    description: "Real Latina amateur cam girls streaming live right now. Genuine Colombian, Mexican, and Brazilian girls new to camming. Authentic, unscripted, totally free to watch.",
    faq: [
      { q: "Are these real amateurs?", a: "Yes — amateur Latina models are typically newer to camming and offer more authentic, unscripted shows." },
    ],
    apiParams: { ethnicity: "hispanic", theme: "amateur" },
    metaDescription: "Latina amateur cam girls live now. Real Colombian, Mexican, Brazilian girls streaming free. Authentic amateur shows.",
    keywords: "latina amateur cam, amateur latina live, real latina cam girls, amateur colombian cam",
  },
  "asian-big-tits": {
    title: "Asian Big Tits Cam Girls",
    h1: "Asian Big Tits Cam Girls Live",
    description: "Beautiful Asian cam girls with big tits streaming live right now. Japanese, Korean, Thai, and Filipino models with gorgeous curves. Free chat, private shows available.",
    faq: [
      { q: "Are these really Asian models with big tits?", a: "Yes — filtered for Asian ethnicity with larger bust sizes for an irresistible combination." },
    ],
    apiParams: { ethnicity: "asian", cupSize: "dd/e,dd" },
    metaDescription: "Asian big tits cam girls live now. Japanese, Korean, Thai models with curves streaming free.",
    keywords: "asian big tits cam, busty asian cam girls, asian busty live, big boobs asian cam",
  },
  "asian-amateur": {
    title: "Asian Amateur Cam Girls",
    h1: "Asian Amateur Cam Girls Live",
    description: "Real Asian amateur cam girls streaming live. Genuine Japanese, Korean, Thai, and Chinese girls new to live camming. Unscripted and totally authentic.",
    faq: [
      { q: "What countries are these Asian amateurs from?", a: "Mostly Japan, Korea, Thailand, Philippines, China, and Vietnam. Use search to find your preferred nationality." },
    ],
    apiParams: { ethnicity: "asian", theme: "amateur" },
    metaDescription: "Asian amateur cam girls live now. Real Japanese, Korean, Thai girls streaming free. Authentic amateur performances.",
    keywords: "asian amateur cam, amateur asian cam girls, real asian live cam, japanese amateur cam",
  },
  "ebony-milf": {
    title: "Ebony MILF Cam Girls",
    h1: "Ebony MILF Cam Girls Live Now",
    description: "Gorgeous ebony MILFs live on cam right now. Mature Black women 30–50 with experience and confidence streaming free. Hot, experienced, and ready to perform.",
    faq: [
      { q: "Are ebony MILFs different from regular ebony cams?", a: "Yes — this filter specifically targets mature Black models 30+, combining two of the most popular categories." },
    ],
    apiParams: { ethnicity: "ebony", ageMin: 30, ageMax: 55 },
    metaDescription: "Ebony MILF cam girls live now. Mature Black women streaming free. Chat or go private with experienced ebony models.",
    keywords: "ebony milf cam, black milf cam girls, mature ebony live cam, black cougar cam",
  },
  "ebony-amateur": {
    title: "Ebony Amateur Cam Girls",
    h1: "Ebony Amateur Cam Girls Live",
    description: "Real ebony amateur cam girls streaming live right now. Genuine Black girls new to camming — authentic, unscripted, and absolutely stunning.",
    faq: [
      { q: "What makes ebony amateurs different?", a: "Amateur ebony models are newer to camming, offering more natural and authentic performances compared to veterans." },
    ],
    apiParams: { ethnicity: "ebony", theme: "amateur" },
    metaDescription: "Ebony amateur cam girls live now. Real Black girls streaming free. Authentic unscripted performances.",
    keywords: "ebony amateur cam, amateur black cam girls, real ebony live cam, amateur ebony webcam",
  },
  "milf-big-tits": {
    title: "MILF Big Tits Cam Girls",
    h1: "MILF Big Tits Cam Girls Live",
    description: "Hot MILF cam girls with big tits live right now. Mature women 30–50 with stunning curves streaming free. The ultimate combo of experience and body.",
    faq: [
      { q: "Do MILF big tits models do private shows?", a: "Absolutely — most MILF performers are very comfortable with private requests. Prices set by each model." },
    ],
    apiParams: { theme: "milf", ageMin: 30, ageMax: 55, bust: "large" },
    metaDescription: "MILF big tits cam girls live now. Mature busty women streaming free. Watch, chat, go private.",
    keywords: "milf big tits cam, busty milf cam girls, mature big boobs cam, milf busty live",
  },
  "blonde-big-tits": {
    title: "Blonde Big Tits Cam Girls",
    h1: "Blonde Big Tits Cam Girls Live",
    description: "Stunning blonde cam girls with big tits streaming live right now. Natural and platinum blondes with gorgeous curves in free chat. Go private anytime.",
    faq: [
      { q: "Are the big tits natural or enhanced?", a: "Both! Many blonde models have natural curves, others enhanced. You can ask models directly in free chat." },
    ],
    apiParams: { hairColor: "blond", bust: "large" },
    metaDescription: "Blonde big tits cam girls live now. Busty blonde models streaming free. Chat or go private.",
    keywords: "blonde big tits cam, busty blonde cam girls, blonde busty live, big boobs blonde cam",
  },
  "brunette-big-tits": {
    title: "Brunette Big Tits Cam Girls",
    h1: "Brunette Big Tits Cam Girls Live",
    description: "Gorgeous brunette cam girls with big tits live streaming right now. Dark-haired busty models in free chat. Private shows always available.",
    faq: [
      { q: "What's the most popular brunette big tits show?", a: "Oil shows, striptease, and interactive toy sessions are top picks for brunette busty performers." },
    ],
    apiParams: { hairColor: "brunette", bust: "large" },
    metaDescription: "Brunette big tits cam girls live now. Busty dark-haired models streaming free.",
    keywords: "brunette big tits cam, busty brunette cam girls, brunette busty live, big boobs brunette",
  },
  "teen-petite": {
    title: "Teen Petite Cam Girls (18+)",
    h1: "Teen Petite Cam Girls Live (18+)",
    description: "Legal 18+ petite teen cam girls streaming live right now. Young, slim, small-framed models in free chat. All performers are verified adults.",
    faq: [
      { q: "Are petite teen cam girls really 18+?", a: "Yes — all performers are age-verified 18 or older. Streamate enforces strict age verification." },
    ],
    apiParams: { ageMin: 18, ageMax: 23, build: "petite" },
    metaDescription: "Teen petite cam girls 18+ live now. Young slim models streaming free. All performers verified adults.",
    keywords: "teen petite cam girls, petite teen cam, slim teen cam girls, young petite cams 18+",
  },
  "bbw-amateur": {
    title: "BBW Amateur Cam Girls",
    h1: "BBW Amateur Cam Girls Live",
    description: "Real BBW amateur cam girls streaming live right now. Plus-size women new to camming — authentic curves, genuine performances, no scripts.",
    faq: [
      { q: "Are BBW amateur shows different from pro shows?", a: "Amateur BBW models are newer to camming and tend to offer more natural, less rehearsed shows." },
    ],
    apiParams: { build: "bbw,large", theme: "amateur" },
    metaDescription: "BBW amateur cam girls live now. Real plus-size women streaming free. Authentic unscripted performances.",
    keywords: "bbw amateur cam, amateur plus size cam girls, real bbw live cam, bbw amateur webcam",
  },
  "mature-big-tits": {
    title: "Mature Big Tits Cam Girls — Busty Women 40+",
    h1: "Mature Big Tits Cam Girls Live",
    description: "Gorgeous mature cam girls with big tits streaming live right now. Women 40+ with incredible curves and decades of experience. Free chat, private shows available.",
    faq: [
      { q: "What age are mature big tits models?", a: "Mature big tits performers are typically 40+. Use the age slider to narrow the range." },
    ],
    apiParams: { ageMin: 40, bust: "large" },
    metaDescription: "Mature big tits cam girls LIVE now — 100+ busty women 40+ streaming free. Watch real curves, go private for custom shows.",
    keywords: "mature big tits cam, older busty cam girls, 40+ big boobs cam, mature busty live",
  },
  "redhead-big-tits": {
    title: "Redhead Big Tits Cam Girls",
    h1: "Redhead Big Tits Cam Girls Live",
    description: "Gorgeous redhead cam girls with big tits streaming live right now. Fiery gingers and natural redheads with stunning curves in free chat.",
    faq: [
      { q: "Are these natural redheads?", a: "Some are natural, some dyed — all stunning. You can ask models in free chat." },
    ],
    apiParams: { hairColor: "redhead", bust: "large" },
    metaDescription: "Redhead big tits cam girls live now. Busty ginger models streaming free.",
    keywords: "redhead big tits cam, busty redhead cam girls, ginger busty live, big boobs redhead cam",
  },
  "squirt-amateur": {
    title: "Amateur Squirt Cam Girls",
    h1: "Amateur Squirt Cam Girls Live",
    description: "Real amateur cam girls who love to squirt, streaming live right now. Authentic performances from models who genuinely enjoy this. Free to watch, go private for requests.",
    faq: [
      { q: "Do amateur squirt models squirt on request?", a: "Most will in private shows. Ask in free chat first to gauge their comfort level." },
    ],
    apiParams: { fetish: "squirt", theme: "amateur" },
    metaDescription: "Amateur squirt cam girls live now. Real girls who love to squirt streaming free.",
    keywords: "amateur squirt cam, squirt cam girls amateur, real squirt live cam, amateur squirting webcam",
  },
  "feet-amateur": {
    title: "Amateur Feet Cam Girls",
    h1: "Amateur Feet Cam Girls Live",
    description: "Real amateur cam girls offering feet shows streaming live right now. Genuine foot fetish performers — soles, arches, toes, nylons — all free to browse.",
    faq: [
      { q: "Do amateur feet cam girls do custom foot content?", a: "Yes — many will do custom foot content in private. Ask in free chat first." },
    ],
    apiParams: { fetish: "feet", theme: "amateur" },
    metaDescription: "Amateur feet cam girls live now. Real foot fetish performers streaming free.",
    keywords: "amateur feet cam, feet cam girls amateur, real foot fetish cam, amateur foot show live",
  },
};


// Related categories for internal linking (SEO)
const RELATED = {
  "latina-cam-girls":           ["brunette-cam-girls","milf-cam-girls","bbw-cam-girls"],
  "blonde-cam-girls":           ["brunette-cam-girls","redhead-cam-girls","teen-cam-girls"],
  "brunette-cam-girls":         ["blonde-cam-girls","latina-cam-girls","mature-cam-girls"],
  "milf-cam-girls":             ["mature-cam-girls","bbw-cam-girls","latina-cam-girls"],
  "teen-cam-girls":             ["blonde-cam-girls","asian-cam-girls","latina-cam-girls"],
  "ebony-cam-girls":            ["latina-cam-girls","bbw-cam-girls","mature-cam-girls"],
  "asian-cam-girls":            ["teen-cam-girls","brunette-cam-girls","ebony-cam-girls"],
  "mature-cam-girls":           ["milf-cam-girls","bbw-cam-girls","brunette-cam-girls"],
  "french-cam-girls":           ["brunette-cam-girls","blonde-cam-girls","milf-cam-girls"],
  "bbw-cam-girls":              ["mature-cam-girls","milf-cam-girls","ebony-cam-girls"],
  "redhead-cam-girls":          ["blonde-cam-girls","teen-cam-girls","brunette-cam-girls"],
  "feet-cam-girls":             ["submissive-cam-girls","voyeur-cam-girls","interactivetoy-cam-girls"],
  "roleplay-cam-girls":         ["dominant-cam-girls","submissive-cam-girls","milf-cam-girls"],
  "bdsm-cam-girls":             ["dominant-cam-girls","submissive-cam-girls","roleplay-cam-girls"],
  "dominant-cam-girls":         ["bdsm-cam-girls","roleplay-cam-girls","mature-cam-girls"],
  "submissive-cam-girls":       ["dominant-cam-girls","bdsm-cam-girls","teen-cam-girls"],
  "squirt-cam-girls":           ["interactivetoy-cam-girls","latina-cam-girls","ebony-cam-girls"],
  "interactivetoy-cam-girls":   ["squirt-cam-girls","roleplay-cam-girls","latina-cam-girls"],
  "voyeur-cam-girls":           ["feet-cam-girls","submissive-cam-girls","interactivetoy-cam-girls"],
  "amateur-cam-girls":          ["teen-cam-girls","college-cam-girls","natural-tits-cam-girls"],
  "college-cam-girls":          ["teen-cam-girls","amateur-cam-girls","blonde-cam-girls"],
  "tattoo-cam-girls":           ["bdsm-cam-girls","dominant-cam-girls","ebony-cam-girls"],
  "big-ass-cam-girls":          ["latina-cam-girls","ebony-cam-girls","bbw-cam-girls"],
  "natural-tits-cam-girls":     ["amateur-cam-girls","teen-cam-girls","blonde-cam-girls"],
  "anal-cam-girls":             ["bdsm-cam-girls","squirt-cam-girls","submissive-cam-girls"],
  "ukrainian-cam-girls":        ["blonde-cam-girls","teen-cam-girls","amateur-cam-girls"],
  "czech-cam-girls":            ["blonde-cam-girls","amateur-cam-girls","ukrainian-cam-girls"],
  "couples-cam":                ["amateur-cam-girls","blowjob-cams","cowgirl-cams"],
  "big-tits-cam-girls":         ["natural-tits-cam-girls","bbw-cam-girls","milf-cam-girls"],
  "masturbation-cams":          ["lovense-cams","squirt-cam-girls","amateur-cam-girls"],
  "striptease-cams":            ["topless-cams","twerk-cams","amateur-cam-girls"],
  "lovense-cams":               ["interactivetoy-cam-girls","masturbation-cams","squirt-cam-girls"],
  "oil-show-cams":              ["big-tits-cam-girls","big-ass-cam-girls","twerk-cams"],
  "dirty-talk-cams":            ["roleplay-cam-girls","masturbation-cams","submissive-cam-girls"],
  "spanish-cam-girls":          ["latina-cam-girls","brunette-cam-girls","french-cam-girls"],
  "blowjob-cams":               ["deepthroat-cams","couples-cam","cowgirl-cams"],
  "deepthroat-cams":            ["blowjob-cams","submissive-cam-girls","anal-cam-girls"],
  "cowgirl-cams":               ["blowjob-cams","couples-cam","masturbation-cams"],
  "topless-cams":               ["striptease-cams","natural-tits-cam-girls","amateur-cam-girls"],
  "twerk-cams":                 ["big-ass-cam-girls","ebony-cam-girls","latina-cam-girls"],
  "ahegao-cams":                ["roleplay-cam-girls","teen-cam-girls","dirty-talk-cams"],
  "indian-cam-girls":           ["asian-cam-girls","latina-cam-girls","arab-cam-girls"],
  "russian-cam-girls":          ["ukrainian-cam-girls","blonde-cam-girls","czech-cam-girls"],
  "arab-cam-girls":             ["indian-cam-girls","latina-cam-girls","brunette-cam-girls"],
  "hd-cams":                    ["amateur-cam-girls","big-tits-cam-girls","natural-tits-cam-girls"],
  "petite-cam-girls":           ["teen-cam-girls","asian-cam-girls","amateur-cam-girls"],
  "muscle-cam-girls":           ["dominant-cam-girls","mature-cam-girls","tattoo-cam-girls"],
  "latina-big-tits":            ["latina-cam-girls","big-tits-cam-girls","latina-milf"],
  "latina-milf":                ["milf-cam-girls","latina-cam-girls","mature-cam-girls"],
  "latina-amateur":             ["latina-cam-girls","amateur-cam-girls","teen-cam-girls"],
  "asian-big-tits":             ["asian-cam-girls","big-tits-cam-girls","asian-amateur"],
  "asian-amateur":              ["asian-cam-girls","amateur-cam-girls","teen-cam-girls"],
  "ebony-milf":                 ["ebony-cam-girls","milf-cam-girls","mature-cam-girls"],
  "ebony-amateur":              ["ebony-cam-girls","amateur-cam-girls","ebony-milf"],
  "milf-big-tits":              ["milf-cam-girls","big-tits-cam-girls","mature-cam-girls"],
  "blonde-big-tits":            ["blonde-cam-girls","big-tits-cam-girls","milf-big-tits"],
  "brunette-big-tits":          ["brunette-cam-girls","big-tits-cam-girls","latina-big-tits"],
  "teen-petite":                ["teen-cam-girls","petite-cam-girls","asian-amateur"],
  "bbw-amateur":                ["bbw-cam-girls","amateur-cam-girls","mature-big-tits"],
  "mature-big-tits":            ["mature-cam-girls","big-tits-cam-girls","milf-big-tits"],
  "redhead-big-tits":           ["redhead-cam-girls","big-tits-cam-girls","blonde-big-tits"],
  "squirt-amateur":             ["squirt-cam-girls","amateur-cam-girls","latina-amateur"],
  "feet-amateur":               ["feet-cam-girls","amateur-cam-girls","squirt-amateur"],
};

// ─── Styled components ─────────────────────────────────────────────────────────
const blink = keyframes`0%{opacity:0}50%{opacity:1}100%{opacity:0}`;
const LiveDot = styled("span")({
  height: 8, width: 8, backgroundColor: "#4CAF50",
  borderRadius: "50%", display: "inline-block", marginRight: 6,
  animation: `${blink} 1.5s ease-in-out infinite`,
});

const PerformerTile = styled(Box)(({ theme }) => ({
  position: "relative", borderRadius: 12, overflow: "hidden",
  cursor: "pointer", backgroundColor: "#111",
  "&:hover .overlay": { opacity: 1 },
  "&:hover img": { transform: "scale(1.05)" },
}));

const Overlay = styled(Box)({
  position: "absolute", inset: 0, opacity: 0, transition: "opacity 0.2s",
  background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 60%)",
  display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: 12,
});

// ─── Slug aliases — map legacy/ethnicity slugs to canonical category slugs ──────
export const SLUG_ALIASES = {
  "hispanic":              "latina-cam-girls",
  "latina":                "latina-cam-girls",
  "black":                 "ebony-cam-girls",
  "asian":                 "asian-cam-girls",
  "blonde":                "blonde-cam-girls",
  "blond":                 "blonde-cam-girls",
  "brunette":              "brunette-cam-girls",
  "milf":                  "milf-cam-girls",
  "mature":                "mature-cam-girls",
  "teen":                  "teen-cam-girls",
  "teen-cam-girls-18":     "teen-cam-girls",   // high-volume search slug → canonical
  "redhead":               "redhead-cam-girls",
  "bbw":                   "bbw-cam-girls",
  "french":                "french-cam-girls",
  "amateur":               "amateur-cam-girls",
  "college":               "college-cam-girls",
  "tattoo":                "tattoo-cam-girls",
  "tattoos":               "tattoo-cam-girls",
  "big-ass":               "big-ass-cam-girls",
  "natural-tits":          "natural-tits-cam-girls",
  "anal":                  "anal-cam-girls",
  "ukrainian":             "ukrainian-cam-girls",
  "czech":                 "czech-cam-girls",
  "couples":               "couples-cam",
  "couple":                "couples-cam",
  "big-tits":              "big-tits-cam-girls",
  "bigtits":               "big-tits-cam-girls",
  "big-boobs":             "big-tits-cam-girls",
  "busty":                 "big-tits-cam-girls",
  "masturbation":          "masturbation-cams",
  "solo":                  "masturbation-cams",
  "striptease":            "striptease-cams",
  "strip":                 "striptease-cams",
  "lovense":               "lovense-cams",
  "oil":                   "oil-show-cams",
  "oil-show":              "oil-show-cams",
  "dirty-talk":            "dirty-talk-cams",
  "spanish":               "spanish-cam-girls",
  "blowjob":               "blowjob-cams",
  "bj":                    "blowjob-cams",
  "deepthroat":            "deepthroat-cams",
  "cowgirl":               "cowgirl-cams",
  "topless":               "topless-cams",
  "twerk":                 "twerk-cams",
  "twerking":              "twerk-cams",
  "ahegao":                "ahegao-cams",
  "indian":                "indian-cam-girls",
  "desi":                  "indian-cam-girls",
  "russian":               "russian-cam-girls",
  "arab":                  "arab-cam-girls",
  "arabic":                "arab-cam-girls",
  "middle-eastern":        "arab-cam-girls",
  "hd":                    "hd-cams",
  "petite":                "petite-cam-girls",
  "slim":                  "petite-cam-girls",
  "skinny":                "petite-cam-girls",
  "muscle":                "muscle-cam-girls",
  "muscular":              "muscle-cam-girls",
  "athletic":              "muscle-cam-girls",
  "fit":                   "muscle-cam-girls",
  // Compound category aliases
  "latina-big-tits-cam-girls":   "latina-big-tits",
  "latina-milf-cam-girls":       "latina-milf",
  "latina-amateur-cam-girls":    "latina-amateur",
  "asian-big-tits-cam-girls":    "asian-big-tits",
  "asian-amateur-cam-girls":     "asian-amateur",
  "ebony-milf-cam-girls":        "ebony-milf",
  "ebony-amateur-cam-girls":     "ebony-amateur",
  "milf-big-tits-cam-girls":     "milf-big-tits",
  "blonde-big-tits-cam-girls":   "blonde-big-tits",
  "brunette-big-tits-cam-girls": "brunette-big-tits",
  "teen-petite-cam-girls":       "teen-petite",
  "bbw-amateur-cam-girls":       "bbw-amateur",
  "mature-big-tits-cam-girls":   "mature-big-tits",
  "redhead-big-tits-cam-girls":  "redhead-big-tits",
  "squirt-amateur-cam-girls":    "squirt-amateur",
  "feet-amateur-cam-girls":      "feet-amateur",
};

// ─── Main component ────────────────────────────────────────────────────────────
const CategoryPage = () => {
  const { slug } = useParams();
  const resolvedSlug = SLUG_ALIASES[slug?.toLowerCase()] || slug;
  const config = CATEGORIES[resolvedSlug];

  // Inject FAQ JSON-LD schema into <head> for SEO
  useEffect(() => {
    if (!config?.faq || config.faq.length === 0) return;
    const schemaId = 'faq-schema-ld';
    // Remove any existing FAQ schema
    const existing = document.getElementById(schemaId);
    if (existing) existing.remove();
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": config.faq.map(({ q, a }) => ({
        "@type": "Question",
        "name": q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": a,
        },
      })),
    };
    const script = document.createElement('script');
    script.id = schemaId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(schemaId);
      if (el) el.remove();
    };
  }, [resolvedSlug, config]);
  const [performers, setPerformers] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [page, setPage]             = useState(1);
  const [hasMore, setHasMore]       = useState(true);
  const [embedPerformer, setEmbedPerformer] = useState(null);
  const [preRollPending, setPreRollPending] = useState(null);

  // Pull SinParty models and filter by mapped category
  const { performers: sinPartyModels } = useContext(SinPartyContext);
  // Pull Stripchat models and filter by mapped category
  const { performers: stripchatModels } = useContext(StripchatContext);
  const scForCategory = (stripchatModels || []).filter(
    p => p.mappedCategories && p.mappedCategories.includes(resolvedSlug)
  );
  const sinPartyForCategory = (sinPartyModels || []).filter(
    p => p.mappedCategories && p.mappedCategories.includes(resolvedSlug)
  );
  // Country-based filtering for Ukrainian / Czech pages
  const countryFiltered = resolvedSlug === 'ukrainian-cam-girls'
    ? (sinPartyModels || []).filter(p => (p.country || '').toLowerCase() === 'ua' || (p.country || '').toLowerCase() === 'ukraine')
    : resolvedSlug === 'czech-cam-girls'
    ? (sinPartyModels || []).filter(p => (p.country || '').toLowerCase() === 'cz' || (p.country || '').toLowerCase() === 'czech republic')
    : [];
  const spModels = [...new Map([...sinPartyForCategory, ...countryFiltered].map(p => [p.uniqueModelId, p])).values()];

  const fetchPerformers = useCallback(async (pageNum = 1, append = false) => {
    if (!config) return;
    setLoading(true);
    try {
      const params = { ...config.apiParams, limit: 24, page: pageNum };
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/performers`, { params });
      const list = Array.isArray(res.data) ? res.data : [];
      if (list.length < 24) setHasMore(false);

      const mapped = list.map((p) => {
        const a = p["@attributes"] || {};
        const gallery = (() => {
          const raw = p?.Media?.PhotoGallery?.Pic;
          if (!raw) return [];
          const pics = Array.isArray(raw) ? raw : [raw];
          return pics.map(pic => pic?.Full?.["@attributes"]?.Src || pic?.Full?.Src || "").filter(Boolean);
        })();
        return {
          id: a.Id,
          name: a.Name,
          age: a.Age,
          ethnicity: a.Ethnicity,
          hairColor: a.HairColor,
          theme: a.Theme,
          language: a.Language,
          goldShow: !!(a.PerfFlag && (parseInt(a.PerfFlag) & 0x00100000)),
          thumb: p?.Media?.Pic?.Thumb?.["@attributes"]?.Src || "",
          full:  p?.Media?.Pic?.Full?.["@attributes"]?.Src  || "",
          gallery,
          about: p?.Descriptions?.About || "",
          chatRoomUrl: `https://instacamgirlslive.com/cam/${a.Name}/?smid=${a.Id}&AFNO=1-94033`,
          embedUrl: `https://hybridclient.naiadsystems.com/purecam?performer=${a.Name}&widescreen=true`,
        };
      });
      setPerformers(prev => append ? [...prev, ...mapped] : mapped);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [config]);

    // Strict round-robin: 1-Cambuilder 2-AWEmpire(n/a in cat) 3-SinParty 4-StripCash
  const mergedPerformers = React.useMemo(() => {
    const normSP = spModels.map(p => ({
      ...p,
      id: p.uniqueModelId,
      name: p.displayName,
      thumb: p.profilePictureUrl,
      full: p.profilePictureFullUrl || p.profilePictureUrl,
      gallery: [],
      chatRoomUrl: p.chatRoomUrl,
      _isSinParty: true,
    }));
    const normSC = scForCategory.map(p => ({
      ...p,
      id: p.uniqueModelId,
      name: p.displayName,
      thumb: p.profilePictureUrl,
      full: p.profilePictureFullUrl || p.profilePictureUrl,
      gallery: [],
      chatRoomUrl: p.chatRoomUrl,
      _isStripchat: true,
    }));
    // Sources in order: Cambuilder, SinParty, StripCash (AWEmpire has no category feed here)
    const sources = [performers, normSP, normSC];
    const maxLen = Math.max(...sources.map(s => s.length));
    const result = [];
    for (let i = 0; i < maxLen; i++) {
      sources.forEach(src => {
        if (src[i]) result.push(src[i]);
      });
    }
    return result;
  }, [performers, spModels, scForCategory]);

  useEffect(() => {
    setPerformers([]);
    setPage(1);
    setHasMore(true);
    fetchPerformers(1, false);
  }, [resolvedSlug, fetchPerformers]);

  const loadMore = () => {
    const next = page + 1;
    setPage(next);
    fetchPerformers(next, true);
  };

  if (!config) {
    return (
      <Box sx={{ p: 6, textAlign: "center" }}>
        <Typography variant="h5">Category not found.</Typography>
        <Button component={Link} to="/" sx={{ mt: 2 }} startIcon={<ArrowBackIcon />}>Back to Home</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fafafa" }}>
      {/* Embed overlay */}
      {preRollPending && (
        <PreRollAd onComplete={() => {
          const p = preRollPending;
          const url = p.chatRoomUrl || `https://instacamgirlslive.com/cam/${encodeURIComponent(p.name)}/?AFNO=1-94033`;
          window.open(url, '_blank');
          setPreRollPending(null);
        }} />
      )}

      {/* Header */}
      <Box sx={{ bgcolor: "#fff", borderBottom: "1px solid #eee", px: { xs: 2, md: 6 }, py: 3 }}>
        <Button component={Link} to="/" startIcon={<ArrowBackIcon />} sx={{ mb: 1, color: "#FF4196" }}>
          All Categories
        </Button>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>{config.h1}</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <LiveDot /><Typography variant="body2" sx={{ color: "#4CAF50", fontWeight: 600 }}>Live Now</Typography>
          {mergedPerformers.length > 0 && (
            <Chip label={`${mergedPerformers.length}+ models online`} size="small"
              sx={{ bgcolor: "#fff0f7", color: "#FF4196", border: "1px solid #FF4196", fontWeight: 600 }} />
          )}
        </Box>
        <Typography variant="body1" sx={{ color: "#555", maxWidth: 720 }}>{config.description}</Typography>
      </Box>

      {/* Grid */}
      <Box sx={{ px: { xs: 1, md: 4 }, py: 3, maxWidth: 1400, mx: "auto" }}>
        <Grid container spacing={2}>
          {loading && mergedPerformers.length === 0
            ? Array.from({ length: 12 }).map((_, i) => (
                <Grid item xs={6} sm={4} md={3} key={i}>
                  <Skeleton variant="rectangular" height={260} sx={{ borderRadius: 2 }} />
                </Grid>
              ))
            : mergedPerformers.map((p, idx) => (
                <Grid item xs={6} sm={4} md={3} key={p.id}>
                  <PerformerTile onClick={() => {
                    if (p._isSinParty || p._isStripchat) {
                      const url = p._isStripchat
                        ? buildStripchatClickUrl(p.chatRoomUrl, 'category')
                        : p.chatRoomUrl;
                      window.open(url, '_blank'); return;
                    }
                    setPreRollPending(p);
                  }}>
                    <Box component="img"
                      src={(p.gallery && p.gallery[0]) || p.full || p.thumb}
                      alt={`${p.name} live cam`}
                      loading={idx < 4 ? "eager" : "lazy"}
                      fetchpriority={idx < 4 ? "high" : undefined}
                      sx={{ width: "100%", height: 260, objectFit: "cover",
                        transition: "transform 0.3s ease", display: "block" }}
                      onError={(e) => { e.target.src = p.thumb || p.full || ""; }}
                    />
                    <Box sx={{
                      position: "absolute", top: 8, left: 8,
                      bgcolor: "rgba(76,175,80,0.9)", borderRadius: "12px",
                      px: 1, py: 0.3, display: "flex", alignItems: "center", gap: 0.5,
                    }}>
                      <LiveDot style={{ marginRight: 2 }} />
                      <Typography sx={{ color: "#fff", fontSize: "0.7rem", fontWeight: 700 }}>LIVE</Typography>
                    </Box>
                    {p.goldShow && (
                      <Chip label="🥇 GOLD" size="small"
                        sx={{ position: "absolute", top: 8, right: 8,
                          bgcolor: "#FFD700", color: "#000", fontWeight: 700, fontSize: "0.65rem", height: 20 }} />
                    )}
                    <Overlay className="overlay">
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                        <Avatar src={p.thumb} sx={{ width: 28, height: 28 }} />
                        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "0.9rem" }}>{p.name}</Typography>
                      </Box>
                      {p.age && (
                        <Typography sx={{ color: "#ddd", fontSize: "0.75rem", mb: 1 }}>
                          {p.age} yrs{p.ethnicity ? ` · ${p.ethnicity}` : ""}
                          {p.hairColor ? ` · ${p.hairColor} hair` : ""}
                        </Typography>
                      )}
                      {p.about && (
                        <Typography sx={{ color: "#bbb", fontSize: "0.72rem", mb: 1, fontStyle: "italic" }}>
                          "{p.about.slice(0, 60)}…"
                        </Typography>
                      )}
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button size="small" variant="contained"
                          sx={{ background: "linear-gradient(45deg,#e91e63,#9c27b0)", borderRadius: "20px",
                            fontSize: "0.7rem", py: 0.5, px: 1.5, flexShrink: 0 }}
                          onClick={(e) => { e.stopPropagation(); setPreRollPending(p); }}>
                          <LiveTvIcon sx={{ fontSize: 13, mr: 0.5 }} /> Watch
                        </Button>
                        <Button size="small" variant="contained"
                          sx={{ background: "linear-gradient(90deg,#7c3aed,#a855f7)", color: "#fff",
                            borderRadius: "20px", fontSize: "0.7rem", py: 0.5, px: 1.5, flexShrink: 0,
                            '&:hover': { background: "linear-gradient(90deg,#6d28d9,#9333ea)" } }}
                          onClick={(e) => { e.stopPropagation(); const _u = p._isStripchat ? buildStripchatClickUrl(p.chatRoomUrl, 'category') : p.chatRoomUrl; window.open(_u, "_blank"); }}>
                          💬 Chat
                        </Button>
                      </Box>
                    </Overlay>
                  </PerformerTile>
                </Grid>
              ))}
        </Grid>

        {hasMore && !loading && mergedPerformers.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Button variant="contained"
              sx={{ background: "linear-gradient(45deg,#FF6B6B,#FF2BAA)", borderRadius: "50px", px: 5, py: 1.5, fontWeight: 700 }}
              onClick={loadMore}>
              Load More Girls
            </Button>
          </Box>
        )}

        {/* SEO FAQ section */}
        {config.faq && (
          <Box sx={{ mt: 6, maxWidth: 800, mx: "auto" }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color: "#333" }}>
              Frequently Asked Questions
            </Typography>
            {config.faq.map((item, i) => (
              <Box key={i} sx={{ mb: 3, pb: 3, borderBottom: "1px solid #eee" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>{item.q}</Typography>
                <Typography variant="body2" sx={{ color: "#666" }}>{item.a}</Typography>
              </Box>
            ))}
          </Box>
        )}

        {/* Internal links to other categories */}
        <Box sx={{ mt: 6, p: 3, bgcolor: "#fff", borderRadius: 2, border: "1px solid #eee" }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>Browse More Categories</Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {Object.entries(CATEGORIES)
              .filter(([s]) => s !== resolvedSlug)
              .map(([s, c]) => (
                <Chip key={s} label={c.title} component={Link} to={`/category/${s}`} clickable
                  sx={{ bgcolor: "#fff0f7", color: "#FF4196", border: "1px solid #FF4196",
                    fontWeight: 600, "&:hover": { bgcolor: "#FF4196", color: "#fff" } }} />
              ))}
          </Box>

          {/* ── SEO Internal Links ─────────────────────── */}
          {RELATED[resolvedSlug] && (
            <Box sx={{ mt: 4, mb: 2 }}>
              <Typography sx={{ fontWeight: 700, mb: 1, color: '#FF4196' }}>
                Also see:
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {RELATED[resolvedSlug].map(rel => (
                  <Link key={rel} to={`/category/${rel}`} style={{ textDecoration: 'none' }}>
                    <Box sx={{ px: 2, py: 0.5, borderRadius: 20, border: '1px solid #FF4196',
                      color: '#FF4196', fontSize: '0.85rem', '&:hover': { bgcolor: '#FF4196', color: '#fff' }, transition: '0.2s' }}>
                      {CATEGORIES[rel]?.title || rel}
                    </Box>
                  </Link>
                ))}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CategoryPage;
